module.exports = __webpack_public_path__ + "static/media/UserIcon.44d7319c.jpg";